import { render, staticRenderFns } from "./FeeItemTax.vue?vue&type=template&id=4f92cd10&scoped=true&"
import script from "./FeeItemTax.vue?vue&type=script&lang=js&"
export * from "./FeeItemTax.vue?vue&type=script&lang=js&"
import style0 from "./FeeItemTax.vue?vue&type=style&index=0&id=4f92cd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f92cd10",
  null
  
)

export default component.exports